const isObjAndNotNull = (obj: any): boolean => {
  return typeof obj === 'object' && obj !== null
}

const debounce = <U>(callback: (...args: any[]) => Promise<U>, wait: number = 250): (...args: any[]) => Promise<U> => {
  let timer = null
  let resolve: (value?: U) => void
  const promise = new Promise<U>((r) => resolve = r)

  return (...args) => {
    clearTimeout(timer)
    const invokeCallback = () => {
      callback(...args).then((response) => resolve(response))
    }

    timer = setTimeout(() => invokeCallback(), wait)

    return promise
  }
}

const escapeRegExp = (str: string): string => {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

const formatAmount = (amount: number): string => {
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export {
  isObjAndNotNull,
  debounce,
  escapeRegExp,
  formatAmount
}



// WEBPACK FOOTER //
// ./src/app/components/data/utils/funcs/index.ts